export default {"src":"/uk/_next/static/media/pension-confident-podcast-logo.3f4bef99.svg","height":150,"width":150,"blurWidth":0,"blurHeight":0};